import FilterRadioButton from '../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../components/FilterRadioButtonsContainer';
import Loader from '../../components/Loader';
import NoData from '../../components/NoData';
import OpacityAnimation from '../../components/OpacityAnimation';
import PageHeader from '../../components/PageHeader';
import Sidebar from '../../components/Sidebar';
import Transitions from '../../components/Transition';
import { useQuery } from '../../hooks/useQuery';
import TableView from './components/TableView';
import ListHeader from './components/header';
import List from './components/list';
import Search from './components/searchAtPage';
import useReclamations from './useReclamations';

export default function ReclamationsAtPeriod() {
  const {
    isLoading,
    fullReclamations,
    doesListApiHasError,
    filteredReclamations,
    pagesQuantity,
    currentPage,
    handlePageChange,
    handleTryAgain,
    listView,
    setListView,
    searchTerm,
    onChangeSearchTerm,
  } = useReclamations();

  const hasReclamations = fullReclamations?.length !== 0 && !!fullReclamations && !isLoading;
  const filteredListLength = filteredReclamations?.length ?? 0;
  const anyResultsByFilterSelection = !filteredReclamations && !isLoading;
  const isListEmpty = !doesListApiHasError && (!isLoading && fullReclamations.length === 0);
  const query = useQuery();
  const returnLink = query.get('returnLink');
  const month = query.get('month');
  const year = query.get('year');
  const active = query.get('active');

  return (
    <>
      <Sidebar active={active ?? 'Home'} />
      <Transitions>
        <Loader isLoading={isLoading} />

        <PageHeader
          title={`Consultas com contestações (${month} / ${year})`}
          link={decodeURIComponent(returnLink ?? '/')}
        />

        {hasReclamations && !isLoading && (
          <>
            <Search
              searchTerm={searchTerm}
              onChangeSearchTerm={onChangeSearchTerm}
            />
          </>
        )}

        {!isLoading && (
          <ListHeader
            doesListExists={hasReclamations}
            hasError={doesListApiHasError}
            filteredListLength={filteredListLength}
            singularLabel="contestação"
            pluralLabel="contestações"
            pagesQuantity={pagesQuantity}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        )}

        {hasReclamations && !isLoading && (
          <>
            <FilterRadioButtonsContainer>
              <FilterRadioButton selected={listView === 'card'} onClick={() => setListView('card')}>
              Cards
              </FilterRadioButton>
              <FilterRadioButton selected={listView === 'table'} onClick={() => setListView('table')}>
              Tabela
              </FilterRadioButton>
            </FilterRadioButtonsContainer>

            {listView === 'card' ? (
              <OpacityAnimation delay={0.2}>
                <List
                  filteredList={filteredReclamations}
                  activeSidebar={active}
                  returnLink={returnLink}
                />
              </OpacityAnimation>
            ) : (
              <OpacityAnimation delay={0.2}>
                <TableView
                  filteredList={filteredReclamations}
                  activeSidebar={active}
                  returnLink={returnLink}
                />
              </OpacityAnimation>
            )}
          </>
        )}

        {!isLoading && (
          <>
            {doesListApiHasError && (
              <NoData
                icon="sad"
                label={(
                  <>
                Ocorreu um erro ao obter as contestações em aberto.
                    <button type="button" onClick={handleTryAgain}>Tentar Novamente</button>
                .
                  </>
                )}
              />
            )}

            {anyResultsByFilterSelection && !doesListApiHasError && (
              <NoData
                icon="searchNotFound"
                label={(
                  <>
                  Não encontramos nenhuma contestação aberta conforme os filtros selecionados.
                  Por favor, tente alterar os critérios.
                  </>
                )}
              />
            )}

            {isListEmpty && !isLoading && (
              <NoData
                icon="emptyBox"
                label={(
                  <>
                Não há nenhuma contestação aberta!
                  </>
                )}
              />
            )}
          </>
        )}

      </Transitions>
    </>
  );
}
